
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/internal/operators/finalize';

import { ChiefsOrderService } from '../../../../services/chiefsOrder.service';
import { LoaderService } from '../../../../common/services/loader.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';

import { Address } from '../../../../common/models/address.model';
import { lettercontentmodel } from '../../../../models/comodel/lettercontentmodel.model';
import { IReportContextValue, ReportTemplate, LetterMergeConstants } from '../../../../models/comodel/mergefieldsmodel.model';
import { mergeFieldsOrgInfo } from '../../../../common/models/organization.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { deepClone } from '../../../../builder/models/editor.model';

@Component({
    selector: 'letter-mergefields',
    templateUrl: './letter-mergefields.component.html',
    styleUrls: ['./letter-mergefields.component.scss'],
    standalone: false
})
export class LetterMergeFieldsComponent implements OnInit, OnDestroy {

    sub: Subscription[] = [];
    orgId: string;
    categoryCode: string;
    reportTemplate: ReportTemplate;
    org: mergeFieldsOrgInfo;
    mergeInfo: IReportContextValue[] = [];
    applicationNumber: string
    titleText: string = '';
    mergefieldsComplete: boolean = false;

    letter: lettercontentmodel = {
        id: '',
        htmlContent: ''
    }

    subHeader: SubHeader = new SubHeader({ title: this.titleText });

    mergeFieldsForm: FormGroup;   

    nextDialog: Dialog = new Dialog("Once you move forward, you will still be able to edit the letter, but you cannot return to this page. Please make sure the values entered are correct. Are you sure you want to proceed?",
        [
            new DialogButton("Continue", true, () => this.onNextDialogConfirm()),
            new DialogButton("Cancel", false, () => this.onNextDialogCancel()),
        ]);

    constructor(
        private activeRoute: ActivatedRoute,
        private service: ChiefsOrderService,
        private readonly loader: LoaderService,
        private subHeaderService: SubHeaderService,
        public dialogService: DynamicDialogService,
        public router: Router
    ) { }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);

        this.reportTemplate = this.activeRoute.snapshot.data['mergeInfo'];
        this.mergeInfo = deepClone(this.reportTemplate.reportContextValues);
        this.org = this.activeRoute.snapshot.data['orgInfo'];
        this.categoryCode = this.activeRoute.snapshot.params['categoryCode'];

        this.applicationNumber = this.org.applicationNumber;
        this.mergeFieldsForm = new FormGroup({});
        this.createCtrlBindInputs();            

        this.titleText = this.reportTemplate.name;
        this.loader.toggleLoader(false);
    }

    ngOnDestroy() {
        this.sub.forEach(s => s.unsubscribe());
    }     

    createCtrlBindInputs(): void {
        this.mergeFieldsForm.addControl('applicationNumber', new FormControl(this.applicationNumber))

        if (this.mergeInfo.length > 0) {
            for (let value of this.mergeInfo.values()) {
                switch (value.contextValue) {
                    case LetterMergeConstants.OrgId.contextValue: value.replaceValue = this.org.organizationId; break;
                    case LetterMergeConstants.OrgName.contextValue: value.replaceValue = this.org.organizationName; break;
                    case LetterMergeConstants.OrgAddress.contextValue: value.replaceValue = this.org.address.street; break;
                    case LetterMergeConstants.OrgCity.contextValue: value.replaceValue = this.org.address.city; break;
                    case LetterMergeConstants.OrgState.contextValue: value.replaceValue = this.org.address.stateCode; break;
                    case LetterMergeConstants.OrgZip.contextValue: value.replaceValue = this.org.address.zipCode; break;
                    default: {
                        break;
                    }
                }

                if (value.replaceValue != value.contextValue) {
                    //we loaded data from session
                    this.mergeFieldsForm.addControl('' + value.displayName + '', new FormControl(value.replaceValue));
                }
                else
                    this.mergeFieldsForm.addControl('' + value.displayName + '', new FormControl('')); 
            }
        }
    }

    public onNextClick(): void {
        this.nextDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.nextDialog);
    }

    public onNextDialogConfirm(): void {
        this.toggleLetter();
    }


    public onNextDialogCancel(): void {

    }

    toggleLetter(): void {

        this.loader.toggleLoader(true);
        const add: Address = {
            street: this.org.address.street,
            city: this.org.address.city,
            stateCode: this.org.address.stateCode,
            zipCode: this.org.address.zipCode,
            suite: '',
            poBox:''
        }     

        for (let value of this.mergeInfo.values())
        {            
            //Only try to replace if it exists
            if (this.mergeFieldsForm.get('' + value.displayName + '')) {
                if (this.mergeFieldsForm.get('' + value.displayName + '').value !== '') {
                    value.replaceValue = this.mergeFieldsForm.get('' + value.displayName + '').value;
                }
            }
            else {
                console.warn("The template doesn't contain the following substring to replace:" + value.displayName + ". It was ignored.");
            }
        }
		this.loader.toggleLoader(false);
        this.mergefieldsComplete = true;
    }

}
